import { useCallback } from 'react';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import Toast from '@trinity/chat-components/components/Toast/index.js';
import { useDownloader } from '@trinity/chat-components/hooks/useDownloader';

type Props =
  IWorkspaceId &
  IWorkspaceFileId;

export const useDownloadFile = (props: Props) => {

  const download = useDownloader();
  const apiClient = useChatApiClient();

  const handleDownload = useCallback(() => {
    return apiClient.workspaces.downloadFile({
      fileId: props.fileId,
      workspaceId: props.workspaceId,
    }).then(({ file, url }) => {
      download({
        url,
        filename: file.name,
      });
    }).catch(e => {
      Toast.error({
        title: 'Error',
        body: `We're sorry, there was an issue with your request`,
      });
      throw e;
    });
  }, [
    download,
    props.workspaceId,
    props.fileId,
  ]);

  return handleDownload;
};